import { SyntheticEvent, useEffect,useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { TabsPanel } from 'design-system/TabPanel/TabPanel';

import PageTopBar from '../Topbar/PageTopBar';

export interface SharedSettingsTab {
  label: string;
  value: string;
}

interface SharedSettingsViewProps {
  tabs: SharedSettingsTab[];
  defaultTab: string;
  headline: string;
  basePath: string;
  onTabChange?: (tab: string) => void;
}

const SharedSettingsView = ({ tabs, defaultTab, headline, basePath, onTabChange }: SharedSettingsViewProps) => {
  const { publisherId, portalId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [tab, setTab] = useState(defaultTab);

  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    const currentTab = pathSegments.pop();
    if (currentTab && tabs.some(t => t.value === currentTab)) {
      setTab(currentTab);
    }
  }, [location, tabs]);

  const handleTabChange = (event: SyntheticEvent, newValue: string) => {
    if (onTabChange) {
      onTabChange(newValue);
    }
    setTab(newValue);
    const id = publisherId || portalId;
    const newPath = `/${basePath}/${id}/settings/${newValue}`;
    navigate(newPath);
  };

  return (
    <TabsPanel
      className="settings-view"
      tabs={tabs}
      headerComponent={<PageTopBar withTabsDesign={true} headline={headline} />}
      handleTabChange={handleTabChange}
      activeTabVal={tab}
    />
  );
};

export default SharedSettingsView;
